module.exports = __webpack_public_path__ + "img/rectangle_female.bdce212a.svg";